import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TollIcon(props: IconProps) {
    return <Icon {...props} iconKey={"toll"}/>
}
